import axios from "axios";
import store from "../store/state";
import router from "../router";
import { Message } from "element-ui";

export let baseUrl = process.env.VUE_APP_BASE_URL;

axios.defaults.withCredentials = true;
axios.defaults.baseURL = baseUrl;

axios.interceptors.request.use(
    function(config) {
        if (
            !config.url.startsWith("/api/user") ||
            config.url === "/api/user/list" ||
            config.url === "/api/user/login_log"
        ) {
            // 在请求拦截中，每次请求，都会加上一个Authorization头
            config.headers.Authorization = `Bearer ${store.token}`;

            // 取url地址的第四位作为projectId, 如果不存在，默认设置为0
            let projectId = window.location.pathname.split("/")[3];
            projectId = projectId ? projectId : 0;
            config.headers["Project"] = projectId;
        }
        return config;
    },
    function(error) {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    function(response) {
        return response; // 安全地返回 response
    },
    function(error) {
        if (axios.isCancel(error)) {
            // 请求被取消
            if (error.message !== "User cancelled the request") {
                Message.error({
                    message: "请求超时，请稍后再试",
                    duration: 2000
                });
            }
        } else {
            // 其他错误
            try {
                let status = error.response ? error.response.status : 0;
                if (status === 401) {
                    router.replace({
                        name: "Login"
                    });
                }
                if (status === 500) {
                    Message.error({
                        message: "服务器内部异常, 请检查",
                        duration: 2000
                    });
                }
                if (status === 403) {
                    Message.error({
                        message: error.response.data.detail,
                        duration: 2000
                    });
                }
            } catch (e) {
                Message.error({
                    message: "服务器连接超时, 请重试",
                    duration: 2000
                });
            }
        }
        return Promise.reject(error);
    }
);

export const login = params => {
    return axios.post("/api/user/login", params).then(res => res.data);
};

export const addProject = params => {
    return axios.post("/api/core/project", params).then(res => res.data);
};

export const updateProject = params => {
    return axios.patch("/api/core/project", params).then(res => res.data);
};

export const deleteProject = config => {
    return axios
        .delete("/api/core/project", config)
        .then(res => res.data);
};

export const getProjectList = () => {
    return axios.get("/api/core/project").then(res => res.data);
};

export const getPagination = url => {
    return axios.get(url).then(res => res.data);
};

export const getUserList = () => {
    return axios.get("/api/user/list").then(res => res.data);
};

export const getDashboard = () => {
    return axios.get("/api/core/dashboard").then(res => res.data);
};

export const getVisit = params => {
    return axios.get("/api/core/visit", params).then(res => res.data);
};

export const getProjectDetail = pk => {
    return axios.get("/api/core/project/" + pk).then(res => res.data);
};

export const updateTree = (treeId, params) => {
    return axios
        .patch("/api/core/tree/" + treeId, params)
        .then(res => res.data);
};

export const getTree = (projectId, params) => {
    return axios
        .get("/api/core/tree/" + projectId, params)
        .then(res => res.data.data);
};

export const getAllConfig = projectId => {
    return axios
        .get("/api/core/config/" + projectId)
        .then(res => res.data);
};

export const getProjectYapiInfo = pk => {
    return axios
        .get("/api/core/project/yapi/" + pk)
        .then(res => res.data);
};

export const addYAPI = projectId => {
    return axios
        .post("/api/core/yapi/" + projectId)
        .then(res => res.data);
};

export const addAPI = params => {
    return axios.post("/api/core/api", params).then(res => res.data);
};

export const updateAPI = (url, params) => {
    return axios
        .patch("/api/core/api/" + url, params)
        .then(res => res.data);
};

export const apiList = params => {
    return axios.get("/api/core/api", params).then(res => res.data);
};

export const delAllAPI = params => {
    return axios.delete("/api/core/api", params).then(res => res.data);
};

export const tagAPI = params => {
    return axios.patch("/api/core/api/tag", params).then(res => res.data);
};

export const delAPI = apiId => {
    return axios.delete("/api/core/api/" + apiId).then(res => res.data);
};

export const copyAPI = (apiId, params) => {
    return axios
        .post("/api/core/api/" + apiId, params)
        .then(res => res.data);
};

export const syncCaseStep = apiId => {
    return axios
        .patch("/api/core/api/sync/" + apiId)
        .then(res => res.data);
};

export const getAPISingle = apiId => {
    return axios.get("/api/core/api/" + apiId).then(res => res.data);
};

export const moveAPI = params => {
    return axios
        .patch("/api/core/api/move_api", params)
        .then(res => res.data);
};

export const getPaginationByPage = params => {
    return axios.get("/api/core/api", params).then(res => res.data);
};

export const runAPIByPk = (apiId, params, cancelToken) => {
    return axios
        .get("/api/core/run_api_pk/" + apiId, {
            params: params,
            cancelToken: cancelToken
        })
        .then(res => res.data);
};

export const runSingleAPI = params => {
    return axios.post("/api/core/run_api", params).then(res => res.data);
};

// TODO: 上传文件接口需要优化，后端当前不存在此接口
export const uploadFile = url => {
    return baseUrl + "/api/core/file/?token=" + store.token;
};

export const addConfig = params => {
    return axios.post("/api/core/config", params).then(res => res.data);
};

export const updateConfig = (configId, params) => {
    return axios
        .patch("/api/core/config/" + configId, params)
        .then(res => res.data);
};

export const configList = params => {
    return axios.get("/api/core/config", params).then(res => res.data);
};

export const delAllConfig = params => {
    return axios.delete("/api/core/config", params).then(res => res.data);
};

export const delConfig = configId => {
    return axios
        .delete("/api/core/config/" + configId)
        .then(res => res.data);
};

export const copyConfig = (configId, params) => {
    return axios
        .post("/api/core/config/" + configId, params)
        .then(res => res.data);
};

export const getConfigPaginationByPage = params => {
    return axios.get("/api/core/config", params).then(res => res.data);
};

export const delAllTest = params => {
    return axios.delete("/api/core/test", params).then(res => res.data);
};

export const testList = params => {
    return axios.get("/api/core/test", params).then(res => res.data);
};

export const runSuiteTree = params => {
    return axios
        .post("/api/core/run_suite_tree", params)
        .then(res => res.data);
};

export const moveCase = params => {
    return axios
        .patch("/api/core/test/move_case", params)
        .then(res => res.data);
};

export const tagCase = params => {
    return axios
        .patch("/api/core/test/tag", params)
        .then(res => res.data);
};

export const runTestByPk = (testId, params) => {
    return axios
        .get("/api/core/run_testsuite_pk/" + testId, params)
        .then(res => res.data);
};

export const runTestByPkWithCancel = (testId, params, cancelToken) => {
    return axios
        .get("/api/core/run_testsuite_pk/" + testId, {
            params: params,
            cancelToken: cancelToken
        })
        .then(res => res.data);
};

export const getTestPaginationByPage = params => {
    return axios.get("/api/core/test", params).then(res => res.data);
};

export const editTest = testId => {
    return axios
        .get("/api/core/teststep/" + testId)
        .then(res => res.data);
};

export const copyTest = (testId, params) => {
    return axios
        .post("/api/core/test/" + testId, params)
        .then(res => res.data);
};

export const delTest = pk => {
    return axios.delete("/api/core/test/" + pk).then(res => res.data);
};

export const syncTest = testId => {
    return axios.put("/api/core/test/" + testId).then(res => res.data);
};

export const addTestCase = params => {
    return axios.post("/api/core/test", params).then(res => res.data);
};

export const updateTestCase = (testId, params) => {
    return axios
        .patch("/api/core/test/" + testId, params)
        .then(res => res.data);
};

export const runSingleTestSuite = params => {
    return axios
        .post("/api/core/run_testsuite", params)
        .then(res => res.data);
};

export const runSingleTest = params => {
    return axios.post("/api/core/run_test", params).then(res => res.data);
};

export const getAPIPaginationByPage = params => {
    return axios.get("/api/core/api", params).then(res => res.data);
};

export const deleteVariables = variableId => {
    return axios
        .delete("/api/core/variables/" + variableId)
        .then(res => res.data);
};

export const variablesList = params => {
    return axios.get("/api/core/variables", params).then(res => res.data);
};

export const getVariablesPaginationByPage = params => {
    return axios.get("/api/core/variables", params).then(res => res.data);
};

export const delAllVariables = params => {
    return axios
        .delete("/api/core/variables", params)
        .then(res => res.data);
};

export const addVariables = params => {
    return axios
        .post("/api/core/variables", params)
        .then(res => res.data);
};

export const updateVariables = (variablesId, params) => {
    return axios
        .patch("/api/core/variables/" + variablesId, params)
        .then(res => res.data);
};

export const loginLogList = params => {
    return axios.get("/api/user/login_log", params).then(res => res.data);
};

export const loginLogPaginationByPage = params => {
    return axios.get("/api/user/login_log", params).then(res => res.data);
};

export const runDebugtalk = params => {
    return axios
        .post("/api/core/debugtalk", params)
        .then(res => res.data);
};

export const updateDebugtalk = params => {
    return axios
        .patch("/api/core/debugtalk", params)
        .then(res => res.data);
};

export const getDebugtalk = debugtalkId => {
    return axios
        .get("/api/core/debugtalk/" + debugtalkId)
        .then(res => res.data);
};

export const delTasks = taskId => {
    return axios
        .delete("/api/core/schedule/" + taskId)
        .then(res => res.data);
};

export const taskList = params => {
    return axios.get("/api/core/schedule", params).then(res => res.data);
};

export const patchTask = (taskId, params) => {
    return axios
        .patch("/api/core/schedule/" + taskId, params)
        .then(res => res.data);
};

export const copyTask = (taskId, params) => {
    return axios
        .post("/api/core/schedule/" + taskId, params)
        .then(res => res.data);
};

export const runTask = taskId => {
    return axios
        .get("/api/core/schedule/" + taskId)
        .then(res => res.data);
};

export const getTaskPaginationByPage = params => {
    return axios.get("/api/core/schedule", params).then(res => res.data);
};

export const addTask = params => {
    return axios.post("/api/core/schedule", params).then(res => res.data);
};

export const updateTask = (taskId, data) => {
    return axios({
        method: "put",
        url: "/api/core/schedule/" + taskId,
        data: data
    }).then(res => res.data);
};

export const reportList = params => {
    return axios.get("/api/core/reports", params).then(res => res.data);
};

export const getReportPaginationByPage = params => {
    return axios.get("/api/core/reports", params).then(res => res.data);
};

export const runMultiTest = params => {
    return axios
        .post("/api/core/run_multi_tests", params)
        .then(res => res.data);
};

export const delReports = reportId => {
    return axios
        .delete("/api/core/reports/" + reportId)
        .then(res => res.data);
};

export const delAllReports = params => {
    return axios
        .delete("/api/core/reports", params)
        .then(res => res.data);
};

export const recordStart = params => {
    return axios
        .get("/api/core/record/start", params)
        .then(res => res.data);
};

export const recordStop = params => {
    return axios
        .get("/api/core/record/stop", params)
        .then(res => res.data);
};

export const getRecordStatus = params => {
    return axios
        .get("/api/core/record/status", params)
        .then(res => res.data);
};

export const recordRemove = params => {
    return axios
        .get("/api/core/record/remove", params)
        .then(res => res.data);
};

export const generateTestCase = params => {
    return axios
        .post("/api/core/record_case", params)
        .then(res => res.data);
};



// WEBPACK FOOTER //
// ./src/restful/api.js